import React from 'react';
import { object, string } from 'prop-types';
import Seo from './Seo';
import Breadcrumbs from './Breadcrumbs';
import Blog from './Blog';
import StaticPage from './StaticPage';
import NotFound from './NotFound';

/**
 * @param {import('prop-types').InferProps<PageContentProps>} props
 */
const PageContent = ({ pageData, title, handle }) => {
    return Object.keys(pageData ?? {}).length > 0 ? (
        <>
            <Seo
                seoTitle={title}
                seoType={'website'}
                canonicalUrl={new URL(`/pages/${pageData.handle}`, process.env.APP_URL).toString()}
            />
            <div
                className={'page-content--heading'}>
                <Breadcrumbs
                    breadcrumbList={[
                        [pageData.title, pageData.handle],
                    ]}
                />
                <h1
                    className={'page-content--title'}>{pageData.title}</h1>
            </div>
            <div
                className={'page-content--body'}>
                {handle === 'blog' ? (
                    <Blog />
                ) : (
                    <StaticPage
                        content={pageData.bodyHtml} />
                )}
            </div>
        </>
    ) : (
        <NotFound />
    );
};
const PageContentProps = {
    pageData: object,
    title: string,
    handle: string,
};
PageContent.propTypes = PageContentProps;
export default PageContent;